import { createApp } from 'vue';
import CustomToast from '@/components/ui/CustomToast.vue';

const ToastPlugin = {
  install(app) {
    
    
    try {
      // Check if the toast container already exists to prevent duplicates
      let toastContainer = document.getElementById('custom-toast-container');
      
      if (toastContainer) {
        
        return;
      }
      
      // Create a dedicated container with a specific ID we can check in DevTools
      toastContainer = document.createElement('div');
      toastContainer.id = 'custom-toast-container';
      toastContainer.setAttribute('data-testid', 'toast-container');
      document.body.appendChild(toastContainer);
      
      
      // Create the Vue app and mount it
      const toastApp = createApp(CustomToast);
      const toastInstance = toastApp.mount(toastContainer);
      
      // Define the global toast API as a local variable first
      // to prevent creating duplicate methods
      const toastApi = {
        add(options) {
          if (!options) return;
          
          // Deduplicate by checking if a similar toast is already showing
          const similarToasts = toastInstance.toasts.filter(t => 
            t.detail === options.detail && 
            t.severity === options.severity
          );
          
          if (similarToasts.length > 0) {
            
            return;
          }
          
          
          const result = toastInstance.add(options);
          return result;
        },
        // Other methods stay the same
        success(detail, summary = 'Success', life = 3000) {
          return this.add({ severity: 'success', summary, detail, life });
        },
        info(detail, summary = 'Information', life = 3000) {
          return this.add({ severity: 'info', summary, detail, life });
        },
        warn(detail, summary = 'Warning', life = 5000) {
          return this.add({ severity: 'warn', summary, detail, life });
        },
        error(detail, summary = 'Error', life = 5000) {
          return this.add({ severity: 'error', summary, detail, life });
        },
        removeAllGroups() {
          toastInstance.removeAll();
          return true;
        },
        removeGroup(group) {
          toastInstance.removeByGroup(group);
          return true;
        },
        clear() {
          return this.removeAllGroups();
        }
      };
      
      // Only register the toast API if it doesn't already exist
      if (!app.config.globalProperties.$customToast) {
        app.config.globalProperties.$customToast = toastApi;
      }
      
      // Replace the PrimeVue toast with our custom toast
      app.config.globalProperties.$toast = toastApi;
      
      // Make it available through provide/inject pattern
      app.provide('toast', toastApi);
      
      
    } catch (error) {
      
    }
  }
};

export default ToastPlugin;
